<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
 MEMBER CENTER              </p>
	</div>
   <div class="mem-full">

 <Center title='4' />

<div class="mem-con">
	<div class="mem-jin">
		
	
	member center / <b>integral</b>
	
		</div>
	<div class="gift-tit">
		<div class="con1">
			<p>Available integral</p>
			<h1>{{integ}}</h1>
		</div>
		<div><router-link to="/user/gifts">
			<p>My exchange</p>
			<h1>{{exchange}}</h1></router-link>
		</div>
	</div>
 <el-tabs v-model="activeName" @tab-click="handleClick">
		    <el-tab-pane label="Good gift of points" name="0">
				
				
					<div class="login-r1">
					<div class="re-tit add-ship">
						<h4>Good gift of points</h4>
						
						
					</div>
				
					   <div class="home-arr gift-con">
						   
					   
					   	   <div class="con">
					   		   <ul>
								
					   				   <li v-for="it in news">
										 
										   
										   <img class="fit" v-if="it.kucun==0" src="../../assets/sold_out.png" />
										   <img class="fit" v-if="it.type==1" src="../../assets/voucher.png" />
										   <div class="pic">
											   <router-link :to="'/product/pand?id='+it.id"> <img :src="it.image" /></router-link>
										   </div>
										   <div class="txt">
											   <p class="gift-t1">
				{{it.title}}</p>
				<p class="convert">
				<!-- <span>{{it.kucun}} converted</span> --></p>
										
				 <div class="point">
				<div> <span>{{it.jifen}}</span> points</div><div v-if="it.type==1" class="h-button" @click="voucher(it.id)">Redeem now</div>
				
					<div class="h-button" @click="title(it)">Redeem now</div>
			
				<!-- <router-link v-else :to="'/product/ord?id='+it.inventoryId">
					<div class="h-button">Redeem now</div>
				</router-link> -->
				</div>
				 
										   </div>
					   				  
					   				   </li>
								
																					
					   				 
					   			   </ul>
								 
					   	   </div>
					   </div>
					   
				   <div class="page">
					     
					     <el-pagination
					       layout="prev, pager, next"
					       :total="total"
						   @current-change="pick">
					     </el-pagination>
					   </div>
					   
					    <el-dialog
					   :visible.sync="dialogVisible"
					      width="1200px"
					     :before-close="handleClose"
					   >
					    <div class="product-st">
					    	 
					    			   <div class="pic">
					    				  <div class="l1">
					    					
					    					 <div class="block">
					    						<img :src="proImg" />
					    					   </div>
					    				  </div>
					    			
					    			   </div>
					    			    <div class="txt">
					    					<h2>{{pro.title}}</h2>
					    					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
					    					<div class="l4">
					    						US$ {{pro.price_sale}}
					    						<span>Tax included</span>
					    					</div>
					    					<div class="l5">
					    						 <el-input-number size="mini"  v-model="num"  :min="1" :max="10" ></el-input-number>
					    						 <div class="cart-but" @click="sandYart">ADD TO CART</div>
					    					</div>
					    					<div class="wishlist">
					    					
					    						<div class="co2">
					    							Share：
					    														<a href="https://www.facebook.com/sharer.php?u=http://en.fmhd.209.qiyundongli.cn/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
					    															
					    														<a href="http://twitter.com/share?text=FuelMe&url=http://en.fmhd.209.qiyundongli.cn/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
					    							<a href="http://service.weibo.com/share/share.php?url=http://en.fmhd.209.qiyundongli.cn/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
					    							
					    						</div>
					    					
					    					</div>
					    				</div>
					    </div>
					    </el-dialog>
				
				
					</div>
				
			</el-tab-pane>
		    <el-tab-pane label="Credit details" name="1">
				
				
				<div class="login-r1">
					<div class="re-tit add-ship">
						<h4>Integral details</h4>
						
					</div>
					
				
					   <div class="home-arr gift-con">
						   
					   <div class="cen-ord1">
					   			  <el-row>
					   				  <el-col span="13">
					  
				SOURCE / USE</el-col>
					   <el-col span="5">INTEGRAL CHANEG </el-col>
					   <el-col span="6"> DATE </el-col>
					
					   			 </el-row>
					   		  </div>
					   	   <div class="integral">
					   		   <ul>
								 
					   			<li v-for="item in hans">
									<div class="cont">
										<el-row>
											 <el-col span="13">
											
											  <p>{{item.remark}}</p>
										</el-col>
											   <el-col span="5"><b>{{item.jifen}}</b> </el-col>
											   <el-col span="6"> {{item.dtTime}}</el-col>
											
											  </el-row>
									</div>
								
								</li>
								
																					
					   				 
					   			   </ul>
								 
					   	   </div>
					   </div>
					   
				   <div class="page">
					     
					     <el-pagination
					       layout="prev, pager, next"
					       :total="totals"
						   @current-change="picks">
					     </el-pagination>
					   </div>
					   
					    <el-dialog
					   :visible.sync="dialogVisible"
					      width="800"
					     :before-close="handleClose"
					   >
					    <div class="product-st">
					    	 
					    			   <div class="pic">
					    				  <div class="l1">
					    					
					    					 <div class="block">
					    						<img :src="proImg" />
					    					   </div>
					    				  </div>
					    			
					    			   </div>
					    			    <div class="txt">
					    					<h2>{{pro.title}}</h2>
					    					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
					    					<div class="l4">
					    						$ {{pro.price_sale}}
					    						<span>Tax included</span>
					    					</div>
					    					<div class="l5">
					    						 <el-input-number size="mini"  v-model="num"  :min="1" :max="10" ></el-input-number>
					    						 <div class="cart-but" @click="sandYart">ADD TO CART</div>
					    					</div>
					    					<div class="wishlist">
					    					
					    						<div class="co2">
					    							Share：
					    														<a href="https://www.facebook.com/sharer.php?u=http://en.fmhd.209.qiyundongli.cn/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
					    															
					    														<a href="http://twitter.com/share?text=FuelMe&url=http://en.fmhd.209.qiyundongli.cn/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
					    							<a href="http://service.weibo.com/share/share.php?url=http://en.fmhd.209.qiyundongli.cn/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
					    							
					    						</div>
					    					
					    					</div>
					    				</div>
					    </div>
					    </el-dialog>
				
				
					</div>
				
				
			</el-tab-pane>
		 
		
		  </el-tabs>


	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
 data() {
    return {
	
	
		num: 1,
		dialogVisible: false,
		info:'',
		news:[],
		notice:[],
		total:'',
		totals:'',
		id:'',
		pro:'',
		proImg:'',
		page:1,
		pages:1,
		channel_id:0,
		hans:'',
		channel:'',
		exchange:0,
		integ:0
		
	
		
    
    };
  },  mounted() {
	  
 this.channel_id = this.$route.query.id;
		this.sandMate();
		this.sandHans();
		this.sandChan();
		this.sandCase();
		this.sandCart();
		
		},methods: {
			finding(it){
				
				this.proImg=it.image
				this.id=it.inventoryId
				this.dialogVisible=true
				this.sandCase()
			
			},
		
			
		sandCase(){
		
			this.$axios({
			  method: "post",
			  url: "service.php?action=product_detail",
			  data: {inventoryId:this.id},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.pro=data.data;
				}
			 
			});
		
		}, buff(item){
				this.channel_id=item
				this.sandMate()
			},handleClose(done) {
			this.num=1
			done();
       
      },sandYart(it){
		  this.id=it.inventoryId
				if(window.localStorage.getItem('user')== "undefined"){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.id,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
					
					
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},
			voucher(id){
			
							this.$axios({
							  method: "post",
							  url: "service.php?action=money_createTicket",
							  data: {ticket_id:id},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
			title(item){
			   let arr = [{
			   					image: item.image,
			   					title:item.title,
			   					price_sale: item.jifen,
			   					num: 1
			   				}]
			   	let product_info = [{
			   		"inventoryId": item.inventoryId,
			   		"productId": item.productId,
			   		"num": 1
			   	}]
				 localStorage.setItem("product_info", JSON.stringify(product_info));
			   localStorage.setItem("order_info", JSON.stringify(arr));
			   this.$router.push({ path: "/product/ord?id="+item.inventoryId });	
			 
		   },
			collect(it){
				this.id=it.inventoryId
							if(window.localStorage.getItem('user')== "undefined"){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:0},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
						pick(item){
							this.page=item;
							this.sandMate()
						},
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=money_jifenPdts",
				  data: {page:this.page},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.news=data.data
						this.total=data.count
						this.exchange=data.my_exchange_num
						this.integ=data.jifen
						
					}
				 
				});
			
			},picks(item){
							this.pages=item;
							this.sandHans()
						},sandHans(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=users_jifenRecord",
				  data: {page:this.pages},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
								
						this.hans=data.data;
						this.totals=data.count
						
					}
				 
				});
			
			},sandChan(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_channel",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.channel=data.data;
						
						
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss" scoped>
	.gift-tit{
		padding: 30px;
		height: 88px;
		background-color: #F8F8F8;
		text-align: center;
		p{
			font-size: 16px;
			font-weight: bolder;
		}
		h1{
			font-size: 41px;
			margin-top: 20px;
		}
		.con1{
			width: 50%;
			border-right: 1px solid #D2D2D2;
			float: left;
		}
		
	}
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 100px;
			padding: 0 20px;
			height:40px;
			line-height: 40px;
			background: #000;
			color: #FFFFFF;
	
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
	.page{
		text-align: center;
		margin:50px auto;
	}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
	font-size: 16px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #333333;
	line-height: 24px;

}
.add-set{
	margin-left: 10px;
}
.convert{
	margin: 10px 0;
	span{
		background: #F8F8F8;
		padding:5px 10px;
	}

}
.home{
	.gift-con{
		.con{
			li{
				height:450px;
				.gift-t1{
					height: 50px;
				}
				.pic{
					height: 280px;
					img{
						height: 280px;
					}
				}
				.point{
					display: flex;
					justify-content: space-between;
					align-items: center;
					span{
						font-size: 20px;
						color: #010101;
						
					}
				}
			}
		}
	}
}
.cen-ord1{
background: #F8F8F8;
padding: 20px;
margin-bottom: 20px;
}
.integral{
	color:#989898;
	li{
		border-bottom: 1px solid #EFEFEF;
		.cont{
				padding: 20px;
			b{
				font-size: 26px;
				color: #1F1F1F;
				text-align: center;
			}
		}
	
	}
}

</style>